import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_page.less'
import Footer from 'marketing-components/dist/components/organisms/footer'
import Header from 'marketing-components/dist/components/organisms/header'
import PayPalNavigation from 'components/common/paypal_navigation'
import CrowdfundingBanner from 'components/pages/crowdfunding/crowdfunding_banner'

class CrowdfundingPage extends React.Component {
  static propTypes = {
    allowEntryBanner: PropTypes.bool,
    children: PropTypes.any,
    isLoggedIn: PropTypes.any,
    isPreview: PropTypes.bool,
    showFooter: PropTypes.bool,
    showHeader: PropTypes.bool,
    paypalDomain: PropTypes.string,
  }

  static defaultProps = {
    showHeader: true,
    showFooter: true,
  }

  renderFooter = () => {
    const footer = document.getElementById('data-footer').innerHTML
    if (footer) {
      const {
        content: { content: footerContent },
      } = JSON.parse(footer)
      const { localeCountry } = footerContent

      return (
        <Footer
          content={footerContent}
          localeCountry={localeCountry}
          flagHref={`https://${
            this.props.paypalDomain
          }/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
        />
      )
    } else {
      return <PayPalNavigation element="footerHtml" />
    }
  }

  renderHeader = () => {
    const headerContent = document.getElementById('data-header').innerHTML
    if (headerContent) {
      const {
        content: { contentLoggedOut: content, config },
      } = JSON.parse(headerContent)

      const props = { content, config }
      return (
        <div styleName={'marketing-header-background'}>
          <Header {...props} />
        </div>
      )
    } else {
      return <PayPalNavigation element="desktopHeaderHtml" />
    }
  }

  render() {
    const headerContent = document.getElementById('data-header').innerHTML
    let contentStyles = ['content-inside']
    if (!this.props.showHeader) {
      contentStyles.push('no-header')
    }
    if (!this.props.showFooter) {
      contentStyles.push('no-footer')
    }

    return (
      <div>
        {this.props.showHeader && (
          <input
            type="checkbox"
            id="toggleNavigation"
            className="vx_globalNav-toggleCheckbox"
          />
        )}
        {this.props.showHeader && this.renderHeader()}
        <div
          className="vx_foreground-container foreground-container"
          styleName="container-background"
        >
          {this.props.showHeader &&
            !headerContent && <PayPalNavigation element="mobileHeaderHtml" />}
          {this.props.allowEntryBanner &&
            !this.props.isPreview && (
              <CrowdfundingBanner isLoggedIn={this.props.isLoggedIn} />
            )}
          <section
            styleName={contentStyles.join(' ')}
            className={
              this.props.allowEntryBanner ? '' : 'vx_mainContent contents'
            }
            id="contents"
            role="main"
          >
            {this.props.children}
            <div styleName="clear" />
          </section>
          {this.props.showFooter && this.renderFooter()}
        </div>
      </div>
    )
  }
}

export default cssModules(CrowdfundingPage, styles, { allowMultiple: true })
